import { useContext, createContext } from "react";

import type FrontendLogger from "../logging/FrontendLogger";

export const LoggingContext = createContext<{ logger?: FrontendLogger }>({
  logger: undefined,
});

export const useLogging = (): FrontendLogger => {
  const { logger } = useContext(LoggingContext);

  // For serverside rendering logger will not be defined, so we'll insert a placeholder
  if (!logger) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
    return {} as FrontendLogger;
  }

  return logger;
};
